import { DocContent } from '../docsData';

const doc: DocContent = {
  title: 'Migrating to Keypair Auth',
  content: `
Snowflake will be disabling single-factor password authentication in the fall of 2025. This means Pliable will need to use key-pair authentication moving forward for enhanced security.

If your Pliable account currently uses username/password authentication, you can migrate to key-pair auth by following these steps:

1. Navigate to your Settings page and disable any scheduled builds temporarily.

2. Navigate to your Warehouse settings page.

3. Select **"Show Advanced Configuration"**

4. Change **"Authentication Method"** to **"Keypair"**

5. Scroll down and hit **"Generate Setup Script"**

6. Have a Snowflake ACCOUNTADMIN run the updated setup script in Snowflake (the important lines are the users and the setting of RSA keys). For example:

\`\`\`sql
use role accountadmin;
begin;
   set user_name   = 'PLIABLE_DATA_USER';
   set loader_user = 'PLIABLE_LOADER_USER';

   -- set rsa keys
   ALTER USER identifier($user_name) SET RSA_PUBLIC_KEY='MIIBIj...e1QIDAQAB';
   ALTER USER identifier($loader_user) SET RSA_PUBLIC_KEY='MIIBIj...B6gTQIDAQAB';

commit;
\`\`\`

7. After the Snowflake users' RSA public keys are set, you can then click **"Validate Connection"** in Pliable to verify the keypair authentication is working.

8. Navigate to your Settings page and re-enable the scheduled builds.
`,
};

export default doc;
